import { render, staticRenderFns } from "./AppNavItems.vue?vue&type=template&id=ed00b860&scoped=true&"
import script from "./AppNavItems.vue?vue&type=script&lang=js&"
export * from "./AppNavItems.vue?vue&type=script&lang=js&"
import style0 from "./AppNavItems.vue?vue&type=style&index=0&id=ed00b860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed00b860",
  null
  
)

export default component.exports